@use "~theme/breakpoints";

.breadcrumbs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(max-content, 25%));
  width: 100%;
}

.tab {
  display: none;

  @include breakpoints.desktop {
    display: flex;
  }
}
